export default __webpack_public_path__ + "static/media/Ellipse15.bc3f994d.svg";